import { Platform } from 'react-native'

export const isWeb = Platform.OS === 'web'
export const isMobile = Platform.OS === 'ios' || Platform.OS === 'android'
export const isIOS = Platform.OS === 'ios'
export const isAndroid = Platform.OS === 'android'

// Constantes individuelles
export const stdFontSizeSmall = 10;
export const stdFontSize = 14;
export const stdFontSizeLarge = 18;
export const stdCouleurRouge = "#E63027";
export const stdCouleurRougeClair = "#FF6B6B";
export const stdCouleurBleu = "#00448F";
export const stdCouleurBleuClair = "#3b8ff0";
export const stdCouleurGris = "#848484";
export const stdCouleurGrisClair = "#6c757d";
export const switchStyle = {
     transform: isIOS ? [{ scaleX: 0.7 }, { scaleY: 0.7 }] : undefined,
};

// Constantes pour la navigation moderne
export const SAFE_AREA_BOTTOM = 15; // Espacement sécurisé en bas

// Style commun pour éviter le chevauchement avec la barre de tabs
export const pageContainerStyle = {
  flex: 1,
  backgroundColor: '#fff',
};

// Hook pour créer des styles avec espacement sécurisé pour les tabs
export const createPageStyles = (customContainer = {}) => ({
  container: {
    ...pageContainerStyle,
    ...customContainer,
  },
});

// Export par défaut pour la compatibilité
export default {
    stdFontSizeSmall,
    stdFontSize,
    stdFontSizeLarge,
    stdCouleurRouge,
    stdCouleurBleu,
    stdCouleurGris,
    stdCouleurGrisClair,
    SAFE_AREA_BOTTOM,
    pageContainerStyle,
}
